import { envs } from 'application/envHandler'
import apiClient from 'core/api'
import AuthService from 'core/auth'
import { MultipleSearchFilter } from '../components/MultipleSearch/types'
import { NpvrFilterAndPagination } from './actions'
import { AxiosFetchNpvrDevicesResponse, AxiosFetchNpvrInfoResponse, AxiosFetchNpvrTimelineResponse } from './types'

export async function fetchTimelineRecordings(hhid: string, deviceId: string) {
  await AuthService.refreshToken();
  return apiClient.get(`${envs.REACT_APP_API_URL}/dvr/${hhid}/${deviceId}/recordings/per-day`) as Promise<AxiosFetchNpvrTimelineResponse>
}

export async function fetchAssociatedDevices(hhid: string) {
  await AuthService.refreshToken();
  return apiClient.get(`${envs.REACT_APP_API_URL}/device-hologram/households/${hhid}/devices`) as Promise<AxiosFetchNpvrDevicesResponse>
}

export async function fetchNpvrInfo(hhid: string, {filter, pagination}: NpvrFilterAndPagination) {
  await AuthService.refreshToken();
  const selectedFilter = filter?.dateSearchForm || filter?.stringSearchForm? setFilters(filter) : {}
  const selectedPagination = pagination? {pageNumber: pagination.pageNumber -1 , pageSize: pagination.pageSize} : {}

  return apiClient.get(`${envs.REACT_APP_API_URL}/npvr/household/${hhid}`, {
    params: {
      recordingType:'cloud',
      ...selectedPagination,
      ...selectedFilter
    }
  }) as Promise<AxiosFetchNpvrInfoResponse>
}

function setFilters(filter: MultipleSearchFilter){
  const filters = <FilterMappedObject>{}
  if(filter.stringSearchForm){
    filter.stringSearchForm.forEach((value, key) => {
      if(value){
        filters[key] = encodeURIComponent(value)
      }
    })
  }
  
  if(filter.dateSearchForm){
    filter.dateSearchForm.forEach((value, key) => {
      if(value.start && value.end){
        filters[`${key}Start`] = new Date(value.start).toISOString()
        filters[`${key}End`] = new Date(value.end).toISOString()

      }
    })
  }

  return filters
}

type FilterMappedObject = {
  [key: string]: string
}